var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgGiftDollar(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M10.61 5.44a1.467 1.467 0 011.461-.379c1.557.463 2.784 1.604 3.429 3.033.645-1.429 1.872-2.57 3.43-3.033a1.472 1.472 0 011.461.381c.388.388.534.948.382 1.462a5.49 5.49 0 01-2.143 2.93h6.87a1.5 1.5 0 011.5 1.5v3c0 .65-.419 1.2-1 1.407v8.592c0 1.378-1.121 2.5-2.5 2.5h-16a2.503 2.503 0 01-2.5-2.5v-8.592c-.581-.207-1-.757-1-1.408v-3c0-.827.673-1.5 1.5-1.5h6.87a5.482 5.482 0 01-2.142-2.93 1.478 1.478 0 01.382-1.463zM6 15.833v8.5c0 .826.673 1.5 1.5 1.5h16c.827 0 1.5-.673 1.5-1.5l-.001-8.416H25l-19-.084zm9.5.767a.4.4 0 01.392.32l.008.08v.44c.912.186 1.6.994 1.6 1.96a.4.4 0 11-.8 0c0-.477-.282-.887-.687-1.08l-.113-.046v2.175l.892.694c.31.241.512.604.553.995a1.38 1.38 0 01-.317 1.042 1.995 1.995 0 01-.966.627l-.162.04v.353a.4.4 0 01-.792.08l-.008-.08v-.352a2.004 2.004 0 01-1.6-1.96.4.4 0 11.8 0c0 .478.282.888.687 1.08l.113.047V20.84l-.892-.693a1.46 1.46 0 01-.553-.997 1.37 1.37 0 01.318-1.04c.256-.304.593-.52.965-.628l.162-.04V17a.4.4 0 01.4-.4zm.4 4.862v1.551c.198-.07.378-.185.517-.35a.583.583 0 00.132-.442.657.657 0 00-.17-.376l-.079-.071-.4-.312zm-.8-3.186c-.198.07-.378.185-.517.35a.584.584 0 00-.132.441c.015.14.075.273.17.377l.079.071.4.311v-1.55zm10.4-7.443h-8.794l2.147 2.147a.5.5 0 01-.707.707l-2.145-2.145v3.291H25.5a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5zm-11.207 0H5.5a.5.5 0 00-.5.5v3a.5.5 0 00.5.5H15v-3.294l-2.146 2.147a.5.5 0 01-.707-.707l2.146-2.146zM19.343 6a.462.462 0 00-.128.02 4.533 4.533 0 00-3.183 3.78 4.526 4.526 0 003.781-3.183.469.469 0 00-.13-.469.496.496 0 00-.34-.149zm-7.686 0a.506.506 0 00-.341.148.47.47 0 00-.13.47A4.532 4.532 0 0014.967 9.8a4.528 4.528 0 00-3.183-3.78.45.45 0 00-.127-.02z"
  }));
}

export default SvgGiftDollar;